const MILES_FACTOR = 0.621371192;
export const kmToMiles = km => km * MILES_FACTOR;
export const milesToKm = mi => mi / MILES_FACTOR;

let EARTH_RADIUS = 6371; // km
let DEG_2_RAD = Math.PI / 180;
export function distanceFrom(from, to, unit, precision) {
	if (!from || !to || from.lat == undefined || from.lon == undefined || to.lat == undefined || to.lon == undefined) {
		return;
	}

	let φ1 = from.lat * DEG_2_RAD;
	let φ2 = to.lat * DEG_2_RAD;
	let Δφ = φ2 - φ1;
	let Δλ = (to.lon - from.lon) * DEG_2_RAD;

	let sinφ = Math.sin(Δφ / 2);
	let sinλ = Math.sin(Δλ / 2);
	let a = sinφ * sinφ + Math.cos(φ1) * Math.cos(φ2) * sinλ * sinλ;
	let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

	let distance = EARTH_RADIUS * c;
	if (unit === 'mi') distance = kmToMiles(distance);

	if (precision != undefined) {
		let roundTo = Math.pow(10, ~~precision);
		distance = Math.round(distance * roundTo) / roundTo;
		// .toFixed ?
	}

	return distance;
}